<template>
  <TimelineCard>
    <template #header>
      <div class="flex items-center gap-2 flex-1 min-w-0">
        <div class="flex items-center gap-2 flex-wrap flex-1 min-w-0">
          <h3 class="text-sm font-semibold text-slate-900">
            System Log
          </h3>

          <TimelineTag
            :icon="getTypeIcon(systemLog.type)"
            :label="SystemLogTypeName[systemLog.type]"
            :variant="getTypeVariant(systemLog.type)"
          />
        </div>
      </div>
    </template>

    <template #content>
      <div
        v-if="systemLog.description"
        class="mt-3 text-[0.85rem] leading-relaxed text-slate-700 sm:text-xs"
      >
        <p class="m-0 break-words font-medium">
          {{ systemLog.description }}
        </p>
      </div>
    </template>

    <template #footer>
      <TimelineFooter
        author-name="System"
        author-icon="mdi:robot-outline"
        :contact="systemLog?.Contact ? {
          id: systemLog.Contact.id,
          firstName: systemLog.Contact.firstName,
          lastName: systemLog.Contact.lastName,
        } : undefined"
        :business="systemLog?.Business ? {
          id: systemLog.Business.id,
          name: systemLog.Business.name,
        } : undefined"
        :created-at="systemLog.createdAt"
      />
    </template>
  </TimelineCard>
</template>

<script setup lang="ts">
import type { SystemLog, SystemLogType, Contact, Business } from '@prisma/client'
import { SystemLogTypeIcon, SystemLogTypeName, SystemLogTypeColor } from '../ActivityFeed/types'
import TimelineCard from '../ActivityFeed/Base/TimelineCard.vue'
import TimelineTag from '../ActivityFeed/Base/TimelineTag.vue'
import TimelineFooter from '../ActivityFeed/Base/TimelineFooter.vue'

interface Props {
  systemLog: SystemLog & {
    Contact?: Contact
    Business?: Business
  }
}

defineProps<Props>()

const getTypeIcon = (logType: SystemLogType): string => {
  if (logType in SystemLogTypeIcon) {
    return SystemLogTypeIcon[logType]
  }
  return 'mdi:information-outline'
}

type VariantType = 'blue' | 'cyan' | 'purple' | 'yellow' | 'orange' | 'lime' | 'indigo' | 'green' | 'red' | 'emerald' | 'amber' | 'gray'

const getTypeVariant = (logType: SystemLogType): VariantType => {
  if (logType in SystemLogTypeColor) {
    const color = SystemLogTypeColor[logType]
    // Map color to variant (most colors match directly)
    const validVariants: readonly VariantType[] = ['blue', 'cyan', 'purple', 'yellow', 'orange', 'lime', 'indigo', 'green', 'red', 'emerald', 'amber', 'gray'] as const
    if (validVariants.includes(color as VariantType)) {
      return color as VariantType
    }
  }
  return 'gray'
}
</script>
